<template>
  <div>
    <div
      ref="modalEl"
      class="modal fade in"
      style="display:block"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="labelId"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="$emit('close')" aria-label="Stäng">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" :id="labelId">{{ title }}</h4>
          </div>
          <div class="modal-body">
            <slot />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="$emit('close')">{{ cancelLabel }}</button>
            <button type="button" class="btn btn-primary" :disabled="confirmDisabled" @click="$emit('confirm')">{{ confirmLabel }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useFocusTrap } from '../composables/useFocusTrap';

let idCounter = 0;

export default defineComponent({
  name: 'ConfirmModal',
  props: {
    title: { type: String, required: true },
    confirmLabel: { type: String, default: 'OK' },
    cancelLabel: { type: String, default: 'Avbryt' },
    confirmDisabled: { type: Boolean, default: false },
  },
  emits: ['confirm', 'close'],
  setup(_, { emit }) {
    const modalEl = ref<HTMLElement | null>(null);
    const labelId = `confirm-modal-label-${++idCounter}`;
    const { activate, deactivate } = useFocusTrap();

    onMounted(() => {
      if (modalEl.value) {
        activate(modalEl.value, { onEscape: () => emit('close') });
      }
    });

    onUnmounted(() => {
      deactivate();
    });

    return { modalEl, labelId };
  },
});
</script>
